import { RowRegistrationStatus } from 'app/shared/features/map-row-selector/models/row-registration-status';
import { RowSelectionItem } from 'app/shared/features/map-row-selector/models/row-selection-item';

export interface RowRegistration {
    rowNumber: number;
    registrationStatus: RowRegistrationStatus;
}

export const createRowRegistrationFromRowSelection = ({
    rowNumber,
    registrationStatus,
}: RowSelectionItem): RowRegistration => ({
    rowNumber,
    registrationStatus,
});
